import { getRevendaIdByPark } from '../../config/auth'
import { Collection, WhereField } from '../../shared/constants'
import { addDoc, deleteDoc, getAllDocsByQueries, getDocById, getDocByQueries } from './collectionBaseWorker'
import { where } from "firebase/firestore"

export const getAllCoupons = async () => {
    return await getAllDocsByQueries({
        collection: Collection.NEW_PLAN_LICENCE_COUPON,
        queries: [
            where(WhereField.REVENDAID, "==", getRevendaIdByPark())
        ]
    })
}

export const getCouponByIdentifier = async ({ identifier }) => {
    return await getDocByQueries({
        collection: Collection.NEW_PLAN_LICENCE_COUPON,
        queries: [
            where(WhereField.IDENTIFIER, "==", identifier)
        ]
    })
}

export const getCouponById = async ({ id }) => {
    return await getDocById({ collection: Collection.NEW_PLAN_LICENCE_COUPON, id: id })
}

export const addCoupon = async (data) => {
    data.revendaId = getRevendaIdByPark()
    const doc = await addDoc({ collection: Collection.NEW_PLAN_LICENCE_COUPON, data: data })
    return doc.id;
}

export const deleteCouponById = async ({ id }) => {
    await deleteDoc({ collection: Collection.NEW_PLAN_LICENCE_COUPON, id: id })
}